import interceptor from '@/plugins/interceptor';
const pathController = '/Product'

export default {
  state: () => ({
    product: []
  }),
  getters: {
    product_productList: state => state.product.map(p => { return {...p, customLabel: `${p.name} | $${p.price}`}}),
    product_product: state => filter => state.product.filter(product => {
      if (filter.name) return product.name.toLowerCase().includes(filter.name.toLowerCase())
      return true;
    }),
  },
  mutations: { 
    product_setProduct(state, value) {
      state.product = value;
    },
    product_updateProduct(state, model) {
      const idx = state.product.findIndex(p => p.id == model.id);
      state.product[idx] = model;
    },
    product_addProduct(state, model) {
      state.product.push(model);
    },
    product_deleteProduct(state, id) {
      const idx = state.product.findIndex(p => p.id == id);
      state.product.splice(idx, 1);
    }
  },
  actions: {
    async product_getAll({ commit, dispatch }, stationId) {
      try {
        const request = await interceptor.authenticate.get(`${process.env.VUE_APP_API_URL}${pathController}/getAll?stationId=${stationId}`);
        commit('product_setProduct', request.data);
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.message}`, title: window.vueApp.$t('left_menu.commercial_config.products'), error: true});
        throw new Error(error);
      }
    },
    async product_create({ commit, dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/create`, model);
        commit('product_addProduct', request.data);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.create'), title: window.vueApp.$t('left_menu.commercial_config.products')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.commercial_config.products'), error: true});
        throw new Error(error);
      }
    },
    async product_update({ commit, dispatch }, model) {
      try {
        const request = await interceptor.authenticate.post(`${process.env.VUE_APP_API_URL}${pathController}/update`, model);
        commit('product_updateProduct', request.data);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.update'), title: window.vueApp.$t('left_menu.commercial_config.products')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.commercial_config.products'), error: true});
        throw new Error(error);
      }
    }, 
    async product_delete({ commit, dispatch }, model) {
      try {
        await interceptor.authenticate.delete(`${process.env.VUE_APP_API_URL}${pathController}/delete?productId=${model.id}`);
        commit('product_deleteProduct', model.id);
        dispatch('notifications_create', {text: window.vueApp.$t('notifications.delete'), title: window.vueApp.$t('left_menu.commercial_config.products')});
      } catch (error) {
        dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${error.response.data ? window.vueApp.$t(`notifications.validation.${error.response.data}`) : error.message}`, title: window.vueApp.$t('left_menu.commercial_config.products'), error: true});
        throw new Error(error);
      }
    },
  }
}

